import sceneMaps from 'assets/map-floor-plans/scene-maps.json';

/**
 * Get map floor plan configuration for a specific scene
 * @param {string} sceneId - The scene ID
 * @returns {Object|null} Map floor plan configuration or null if not found
 */
export const getSceneMapFloorPlan = (sceneId) => {
  if (!sceneId) return null;

  // Try to get specific scene map
  const sceneMap = sceneMaps[sceneId];
  if (sceneMap) {
    return sceneMap;
  }

  // Fallback to default map
  return sceneMaps.default;
};

/**
 * Get all available map floor plans
 * @returns {Object} All scene maps
 */
export const getAllSceneMaps = () => {
  return sceneMaps;
};

/**
 * Check if scene has custom map floor plan
 * @param {string} sceneId - The scene ID
 * @returns {boolean} True if scene has custom map
 */
export const hasCustomMapFloorPlan = (sceneId) => {
  return sceneMaps[sceneId] && sceneMaps[sceneId] !== sceneMaps.default;
};

/**
 * Get layout type for scene
 * @param {string} sceneId - The scene ID
 * @returns {string} Layout type ('apartment', 'default', etc.)
 */
export const getSceneLayoutType = (sceneId) => {
  const sceneMap = getSceneMapFloorPlan(sceneId);
  return sceneMap?.layout || 'default';
};
